module.exports = __webpack_public_path__ + "media/images/athletes/3532-cd5b6bd324bf41fd4af2fedd6facf42a.png";